import React from 'react';
import styles from './caseStudyComingSoonBanner.module.scss';
import ctaStyles from '../cards/homeCards/projectShowcaseCard.module.scss';

export default function CaseStudyComingSoonBanner({ imageSrc, title, children, ctaHref, ctaLabel }) {
  const titleId = React.useId();

  return (
    <section className={styles.banner} aria-labelledby={titleId}>
      <div className={styles.topRow}>
        <img className={styles.icon} src={imageSrc} alt="" width={82} height={93} />
        <div className={styles.text}>
          <h2 id={titleId} className={styles.title}>
            {title}
          </h2>
          <div className={styles.body}>{children}</div>
        </div>
      </div>
      <div className={styles.ctaRow}>
        <a href={ctaHref} className={ctaStyles.cta}>
          {ctaLabel}
        </a>
      </div>
    </section>
  );
}
